// 统一的页面布局配置
export const LAYOUT_CONFIG = {
  // 页面容器最大宽度
  PAGE_MAX_WIDTH: 'max-w-5xl', // 1024px (xl)

  // 内容区域最大宽度
  CONTENT_MAX_WIDTH: 'max-w-3xl', // 768px (2xl)

  // 设置页面专用宽度（内容相对较少）
  SETTINGS_MAX_WIDTH: 'max-w-2xl', // 672px (xl)

  // 页面内边距
  PAGE_PADDING: 'px-4 sm:px-6 lg:px-8',

  // 页面垂直间距
  PAGE_SPACING: 'py-6',

  // 底部导航栏高度预留空间
  BOTTOM_NAVIGATION_PADDING: 'pb-20',

  // 响应式断点
  BREAKPOINTS: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
  }
};